"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var dayjs_1 = __importDefault(require("dayjs"));
var formTypes_1 = require("../types/formTypes");
var transformAvailableRanges = function (data) {
    var entries = data.map(function (item) {
        return __assign(__assign({}, item), { visiblity: false, startDate: dayjs_1.default(item.start_date).toDate(), endDate: dayjs_1.default(item.end_date).toDate(), state: formTypes_1.UPDATED });
    });
    return entries;
};
exports.default = transformAvailableRanges;
